import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'ui-icon-tile',
  templateUrl: './icon-tile.component.html',
  styleUrl: './icon-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconTileComponent {
  /**
   * Material icon identifier.
   */
  @Input() public matIcon = '';
  /**
   * Icon title
   */
  @Input() public title = '';
  /**
   * Show shadow border.
   */
  @Input() public showShadow = false;
  /**
   * If true displays an external link icon.
   * Default is false.
   */
  @Input() public isExternal = false;

  @Output() public tileClicked = new EventEmitter<void>();

  public onClick(): void {
    this.tileClicked.emit();
  }
}
